/**
 * When the leave-window may open, and how often.
 *
 * Unsigned visitors only. Two signals: the cursor leaving through the top of
 * the window (bounce), and — on a first visit after a search — scrolling
 * through the first five listing results. At most once per browser per day.
 */
export const LISTING_FIFTH_PRODUCT_EVENT = "kono-listing-fifth-product";
export const LISTING_FIFTH_SEEN_KEY = "kono_listing_fifth_seen";
export const EXIT_INTENT_SHOWN_KEY = "kono_exit_intent_shown_on";
export const LAST_ACCOUNT_EMAIL_KEY = "kono_last_account_email";

export const calendarDayKey = (now = new Date()): string =>
  `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}-${String(
    now.getDate(),
  ).padStart(2, "0")}`;

export const hasShownExitIntentToday = (now = new Date()): boolean => {
  try {
    return localStorage.getItem(EXIT_INTENT_SHOWN_KEY) === calendarDayKey(now);
  } catch {
    return false;
  }
};

export const markExitIntentShownToday = (now = new Date()): void => {
  try {
    localStorage.setItem(EXIT_INTENT_SHOWN_KEY, calendarDayKey(now));
  } catch {
    /* private mode / blocked storage */
  }
};

/** A first visit is this browser's first counted trip, or an unknown count. */
export const isFirstTimeVisit = (visits: number): boolean =>
  !Number.isFinite(visits) || visits <= 1;

export const rememberAccountEmail = (email: string): void => {
  const trimmed = email.trim().toLowerCase();
  if (!trimmed) return;
  try {
    localStorage.setItem(LAST_ACCOUNT_EMAIL_KEY, trimmed);
  } catch {
    /* ignore */
  }
};

export const rememberedAccountEmail = (): string => {
  try {
    return (localStorage.getItem(LAST_ACCOUNT_EMAIL_KEY) || "").trim();
  } catch {
    return "";
  }
};

export const notifyFifthProductScrolled = (): void => {
  try {
    sessionStorage.setItem(LISTING_FIFTH_SEEN_KEY, "1");
  } catch {
    /* ignore */
  }
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(LISTING_FIFTH_PRODUCT_EVENT));
};

export const hasScrolledFifthProduct = (): boolean => {
  try {
    return sessionStorage.getItem(LISTING_FIFTH_SEEN_KEY) === "1";
  } catch {
    return false;
  }
};

export const isBounceLeave = (e: MouseEvent): boolean => {
  if (e.relatedTarget || (e as MouseEvent & { toElement?: EventTarget }).toElement) {
    return false;
  }
  return e.clientY <= 0;
};
